export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const SET_SIMPLE_CUSTOMERS = 'SET_SIMPLE_CUSTOMERS';
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_CUSTOMER_ORDERS = 'SET_CUSTOMER_ORDERS';
export const SET_CUSTOMER_OBJECTS = 'SET_CUSTOMER_OBJECTS';
export const SET_CUSTOMER_BLOCKING = 'SET_CUSTOMER_BLOCKING';
